import { render } from "./OrderReEdit.vue?vue&type=template&id=362233c4&scoped=true"
import script from "./OrderReEdit.vue?vue&type=script&lang=js"
export * from "./OrderReEdit.vue?vue&type=script&lang=js"

import "./OrderReEdit.vue?vue&type=style&index=0&id=362233c4&lang=scss&scoped=true"

import exportComponent from "/Users/yllian/RolnnData/Project/m2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-362233c4"]])

export default __exports__